var map = {
	"./fonts/Akhand-Regular.otf": [
		1960,
		1960
	],
	"./fonts/Akhand-Soft.otf": [
		8530,
		8530
	],
	"./fonts/Avenir-Next-Heavy.ttf": [
		7170,
		7170
	],
	"./fonts/Avenir-Next-Regular.ttf": [
		5603,
		5603
	],
	"./fonts/Lato-Light.ttf": [
		7622,
		7622
	],
	"./fonts/Lato-Regular.ttf": [
		4694,
		4694
	],
	"./fonts/Oswald-Medium.ttf": [
		9211,
		9211
	],
	"./png/SummaryBG.webp": [
		1389
	],
	"./png/SummaryImg.webp": [
		7065,
		7065
	],
	"./png/background.webp": [
		1606,
		1606
	],
	"./png/daylight-outdoors.webp": [
		4474,
		4474
	],
	"./png/dedicated-indoor-pair.webp": [
		960
	],
	"./png/dedicated-sun-pair-new.webp": [
		5492
	],
	"./png/dedicated-sun-pair.webp": [
		923,
		923
	],
	"./png/general/01.webp": [
		2740
	],
	"./png/general/02.webp": [
		7265
	],
	"./png/general/03.webp": [
		7510,
		7510
	],
	"./png/general/03_new.webp": [
		5855
	],
	"./png/general/04.webp": [
		6235
	],
	"./png/general/05.webp": [
		1992
	],
	"./png/general/06.webp": [
		6949,
		6949
	],
	"./png/general/06_new.webp": [
		1052
	],
	"./png/general/07.webp": [
		3594,
		3594
	],
	"./png/general/07_new.webp": [
		7971
	],
	"./png/general/08.webp": [
		7231,
		7231
	],
	"./png/general/08_new.webp": [
		866
	],
	"./png/general/09.webp": [
		5692,
		5692
	],
	"./png/general/09_new.webp": [
		3305,
		3305
	],
	"./png/general/09_new_2.webp": [
		9884
	],
	"./png/general/10.webp": [
		2130,
		2130
	],
	"./png/general/10_A_NEW.webp": [
		8715,
		8715
	],
	"./png/general/10_A_NEW_2.webp": [
		2598
	],
	"./png/general/10_new.webp": [
		9019,
		9019
	],
	"./png/general/10_new_2.webp": [
		4918
	],
	"./png/general/11.webp": [
		6845,
		6845
	],
	"./png/general/11_new.webp": [
		9316
	],
	"./png/general/12.webp": [
		4016
	],
	"./png/indoor-pair-oakley.webp": [
		3218
	],
	"./png/indoor-pair_rayban.webp": [
		4796
	],
	"./png/indoor-work.webp": [
		7997,
		7997
	],
	"./png/near-distance.webp": [
		3548,
		3548
	],
	"./png/oakley.webp": [
		2683
	],
	"./png/offer-card_oakley-1.webp": [
		2961
	],
	"./png/offer-card_oakley-2.webp": [
		4852
	],
	"./png/offer-card_oakley-3.webp": [
		9559
	],
	"./png/offer-card_rayban-1.webp": [
		9321
	],
	"./png/offer-card_rayban-2.webp": [
		8812
	],
	"./png/offer-card_rayban-3.webp": [
		6751
	],
	"./png/otherbrands.webp": [
		5926
	],
	"./png/outdoor-leisure.webp": [
		8436,
		8436
	],
	"./png/outdoor-sport.webp": [
		1985,
		1985
	],
	"./png/rayban.webp": [
		2163
	],
	"./png/recom-banner-general.webp": [
		9816
	],
	"./png/recom-banner-oakley.webp": [
		669
	],
	"./png/recom-banner-rayban.webp": [
		2265
	],
	"./png/romi-offer-banner.webp": [
		6305
	],
	"./png/romi-offer-card.webp": [
		6625
	],
	"./png/sun-pair-oakley.webp": [
		9411
	],
	"./png/sun-pair_rayban.webp": [
		2037
	],
	"./png/varilux-physio-1.webp": [
		9372
	],
	"./png/varilux-physio-2.webp": [
		9049
	],
	"./png/varilux-physio-3.webp": [
		4366
	],
	"./svg/accept.svg": [
		6051,
		6051
	],
	"./svg/chevron-down.svg": [
		3313,
		3313
	],
	"./svg/chevron-left-white.svg": [
		2806,
		2806
	],
	"./svg/chevron-left.svg": [
		42,
		42
	],
	"./svg/chevron-right-blue.svg": [
		7894,
		7894
	],
	"./svg/chevron-right.svg": [
		9777,
		9777
	],
	"./svg/close-with-bg.svg": [
		8566,
		8566
	],
	"./svg/decline.svg": [
		4755,
		4755
	],
	"./svg/easy-to-clean.svg": [
		9273,
		9273
	],
	"./svg/france.svg": [
		6262,
		6262
	],
	"./svg/general-bullet-point.svg": [
		7791,
		7791
	],
	"./svg/lens-correct.svg": [
		7610,
		7610
	],
	"./svg/lens-crafters-logo.svg": [
		2350,
		2350
	],
	"./svg/lens-enhance.svg": [
		8742,
		8742
	],
	"./svg/lens-protect.svg": [
		4541,
		4541
	],
	"./svg/lensCorrect_white.svg": [
		4941,
		4941
	],
	"./svg/lensEnhance_white.svg": [
		9205,
		9205
	],
	"./svg/lensProtect_white.svg": [
		9630,
		9630
	],
	"./svg/lenses-center-white.svg": [
		7175,
		7175
	],
	"./svg/lenses-left-white.svg": [
		8751,
		8751
	],
	"./svg/lenses-oakley.svg": [
		1319,
		1319
	],
	"./svg/lenses-rayban.svg": [
		4251,
		4251
	],
	"./svg/lenses-right-white.svg": [
		3910,
		3910
	],
	"./svg/lenses.svg": [
		2763,
		2763
	],
	"./svg/logo-oakley.svg": [
		9996,
		9996
	],
	"./svg/logo-rayban.svg": [
		4452,
		4452
	],
	"./svg/oakley-bullet-point.svg": [
		1100,
		1100
	],
	"./svg/rayban-bullet-point.svg": [
		500,
		500
	],
	"./svg/usa.svg": [
		3096,
		3096
	],
	"./svg/uv-protection.svg": [
		3086,
		3086
	],
	"./svg/vision-score.svg": [
		7874,
		7874
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3371;
module.exports = webpackAsyncContext;